import React from "react";
import { useAuth } from "../lib/auth";
import { Eye, X } from "@phosphor-icons/react";

export default function ImpersonationBanner() {
  const { isImpersonating, impBy, user } = useAuth();
  if (!isImpersonating || !user) return null;
  const exit = () => {
    sessionStorage.removeItem("cr_token");
    if (window.opener && !window.opener.closed) window.close();
    else window.location.href = "/";
  };
  return (
    <div
      className="w-full bg-[#CBA35C]/25 border-b border-[#CBA35C]/40 text-[#5A4312]"
      data-testid="impersonation-banner"
    >
      <div className="max-w-7xl mx-auto px-6 py-2.5 flex items-center gap-3 text-sm">
        <Eye size={18} weight="duotone" className="shrink-0" />
        <p className="flex-1 truncate">
          <span className="font-semibold">View-as mode:</span>{" "}
          you are viewing <span className="mono">{user.email}</span> ·{" "}
          impersonated by <span className="mono">{impBy?.email}</span>
        </p>
        <button
          onClick={exit}
          className="inline-flex items-center gap-1 rounded-lg bg-[#5A4312] text-[#FBF9F6] px-3 py-1.5 hover:bg-[#3F2E0D] transition"
          data-testid="impersonation-exit"
        >
          <X size={14} /> Exit
        </button>
      </div>
    </div>
  );
}
